import ValidateLandingServices from '@/modules/validate_landing/services/validateLanding.services';

export default class SendCodeRequestService {
  constructor() {
    this.mobilePhones = [];
    this.selected = {};
  }

  setMobilePhones(data) {
    this.mobilePhones = data;
    [this.selected] = data;
  }

  async send(key) {
    await new ValidateLandingServices().sendSms(key, {
      contact_communication_info_id: this.selected.contact_communication_info_id,
    });
  }
}
